import { render, staticRenderFns } from "./PosterFrawing.vue?vue&type=template&id=7b3e18c2"
import script from "./PosterFrawing.vue?vue&type=script&lang=js"
export * from "./PosterFrawing.vue?vue&type=script&lang=js"
import style0 from "./PosterFrawing.vue?vue&type=style&index=0&id=7b3e18c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports